<div class="pickuptime">
    <div >
        <ul #divHours>
            <li *ngFor="let i of hours" (click)="setHour(i)" [ngClass]="{'active': i == hour}">{{(i)| number:'2.0'}}</li>
        </ul>
    </div>
    <div >
        <ul #divMinutes>
            <li *ngFor="let i of minutes" (click)="setMinute(i)" [ngClass]="{'active': i == minute}">{{(i)| number:'2.0'}}</li>
        </ul>
    </div>
    <div class="pickup-now" (click)="setNow()">
        <span class="artstuff-hyperlink">{{'NOW'|translate}}</span>
    </div>
</div>
